export default [
  {
    path: '/laboratory',
    name: 'laboratory',
    redirect: { name: 'statistic' },
    meta: {
      access: 'branchView'
    },
    component: () => import('@/views/Laboratory/LaboratoryView'),
    children: [
      {
        path: 'statistic',
        name: 'statistic',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Laboratory/Statistic')
      },
      {
        path: 'contracts',
        name: 'contracts',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Contract/Contracts')
      },
      {
        path: 'branch',
        name: 'branch',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Laboratory/BranchTable')
      },
      {
        path: 'info',
        name: 'info',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Laboratory/Info')
      }
    ]
  },
  {
    path: '/laboratory/statement-branch/:id',
    name: 'statement-branch-item',
    meta: {
      access: 'branchCreate'
    },
    component: () => import('@/views/Laboratory/StatementInfo.vue')
  },
  {
    path: '/laboratory/branch/:id',
    name: 'branch-item',
    redirect: { name: 'branch-mtz' },
    meta: {
      access: 'branchView'
    },
    component: () => import('@/views/Branches/Info'),
    children: [
      {
        path: 'mtz',
        name: 'branch-mtz',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/MTZ'),
        children: [
          {
            path: 'work-line/:work_line_id',
            name: 'branch-work-line',
            meta: {
              access: 'branchView'
            },
          }
        ]

      },
      {
        path: 'users',
        name: 'branch-users',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/User')
      },
      {
        path: 'users/:user_id',
        name: 'branch-users-form',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/Detail/BranchUserForm')
      },
      {
        path: 'users/:user_id/view',
        name: 'branch-users-view',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/Detail/BranchUserView')
      },
      {
        path: 'statistic',
        name: 'branch-statistic',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/Statistic')
      },
      {
        path: 'info',
        name: 'branch-info',
        meta: {
          access: 'branchView'
        },
        component: () => import('@/views/Branches/Branch/Info')
      }
    ]
  },
  {
    path: '/laboratory/contracts/add',
    name: 'addContractVL',
    meta: {
      access: 'viewContractOCInfo'
    },
    component: () => import('@/views/Contract/AddAndUpdateContract')
  },
  {
    path: '/laboratory/contracts/update/:id',
    name: 'viewContractOCInfo',
    meta: {
      access: 'viewContractOCInfo'
    },
    component: () => import('@/views/Contract/AddAndUpdateContract')
  },

  {
    path: '/branches/document-naau',
    name: 'document-naau',
    meta: {
      access: 'branchCreate'
    },
    component: () => import('@/views/Branches/NAAU/Form')
  },
  {
    path: '/branches/check-equipment',
    name: 'branches-check-equipment',
    meta: {
      access: 'branchCreate'
    },
    component: () => import('@/views/Branches/CheckEquipment/CheckEquipment')
  }
]
